export const environment = {
  PRODUCTION: false,
  ENV: 'DEV',
  PRODUCT: 'SCOTPOWER',
  MODULE: 'BUSINESS',
  SUB_MODULE: 'SCOTPOWER',
  IDENTIFIER: 'U2FsdGVkX1822QSYaw7ipQadMskEG6emEEQeemR/7XU=',
  API_URL: 'https://api.spbusinessenergy.dev.perse.io/bus',
  AUTH_URL: 'https://api.spbusinessenergy.dev.perse.io/',
  DOMESTIC_PORTAL_URL: 'https://www.scottishpower.co.uk/',
  SOCKET_PRESENCE: {
    ENABLED: false,
    SERVER_URL: ''
  },
  APP_VERSION: '1.6.0'
};
